
/**
 * Module dependencies.
 */

import pathToRegexp from 'path-to-regexp';

/**
 * Export `routeTemplate`.
 */

export function routeTemplate(route: string, interpolations: any): string {
  try {
    return pathToRegexp.compile(route)(interpolations);
  } catch (error) {
    return '#';
  }
}
